// extracted by mini-css-extract-plugin
module.exports = {"paper":"a4-qr-10x10_paper__csQV-","page":"a4-qr-10x10_page__1XW5T","label":"a4-qr-10x10_label__1jIDk","label_unique_id":"a4-qr-10x10_label_unique_id__19HAm"};